import React from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../i18n/i18n.js';
import './AuthPrompt.css';

class AuthPrompt extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { 
      showContinueWithoutAuth = false,
      onContinueWithoutAuth = null,
      loginUrl = '/sign-in',
      registerUrl = '/account_create',
      title = null,
      benefits = null
    } = this.props;

    const defaultTitle = i18n.t('authPromptTitle');
    const defaultBenefits = [
      i18n.t('authPromptBenefit1'),
      i18n.t('authPromptBenefit2'),
      i18n.t('authPromptBenefit3')
    ];

    return (
      <div className="auth_prompt">
        <div className="auth_prompt_content">
          <h2 className="auth_prompt_title">
            {title || defaultTitle}
          </h2>

          <ul className="auth_prompt_benefits">
            {(benefits || defaultBenefits).map((benefit, index) => (
              <li key={index}>{benefit}</li>
            ))}
          </ul>

          <div className="auth_prompt_actions">
            <Link data-type="in_app" to={registerUrl} className="button button_primary">
              {i18n.t('authPromptRegisterButton')}
            </Link>

            <Link data-type="in_app" to={loginUrl} className="button button_secondary">
              {i18n.t('authPromptLoginButton')}
            </Link>

            {showContinueWithoutAuth && (
              <button 
                type="button" 
                className="button button_text"
                onClick={onContinueWithoutAuth}
              >
                {i18n.t('authPromptContinueWithoutAuth')}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

}

export default AuthPrompt;
